import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { Box, Input } from '@betty/moonlight';
import { TextInput } from 'react-native';
import { BirthdayInputProps } from './BirthdayInput.types';
import { useSelector } from '@betty/toolkit/state';
import { selectAccountBirthDay } from '../../../../state';

function BirthdayInput({
  setIsBirthdayValid,
  refMonthInput,
}: BirthdayInputProps) {
  const userBirthdayValues = useSelector(selectAccountBirthDay);

  const dayRef = useRef<TextInput>(null);
  const yearRef = useRef<TextInput>(null);

  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');

  const onDayChange = useCallback((value: string) => {
    const day = value.replace(/[^0-9]/g, '').slice(0, 2);

    setDay(day);

    if (day.length === 2) {
      yearRef.current?.focus();
    }
  }, []);

  const onMonthChange = useCallback((value: string) => {
    const month = value.replace(/[^0-9]/g, '').slice(0, 2);

    setMonth(month);

    if (month.length === 2) {
      dayRef.current?.focus();
    }
  }, []);

  const onYearChange = useCallback((value: string) => {
    const year = value.replace(/[^0-9]/g, '').slice(0, 4);

    setYear(year);
  }, []);

  useEffect(() => {
    const normalizedDay = day.padStart(2, '0');
    const normalizedMonth = month.padStart(2, '0');

    const isBirthdayValid =
      userBirthdayValues === `${year}-${normalizedMonth}-${normalizedDay}`;

    setIsBirthdayValid(isBirthdayValid);
  }, [day, month, year, setIsBirthdayValid, userBirthdayValues]);

  return (
    <Box>
      <Box flexDirection="row" gap="space-200">
        <Input
          ref={refMonthInput}
          flex={1}
          keyboardType="numeric"
          placeholderNS="responsibleGaming"
          placeholderKey="month"
          enterKeyHint="go"
          value={month}
          onChangeText={onMonthChange}
        />
        <Input
          ref={dayRef}
          flex={1}
          keyboardType="numeric"
          placeholderNS="responsibleGaming"
          placeholderKey="day"
          enterKeyHint="go"
          value={day}
          onChangeText={onDayChange}
        />
        <Input
          ref={yearRef}
          flex={1}
          keyboardType="numeric"
          placeholderNS="responsibleGaming"
          placeholderKey="year"
          enterKeyHint="go"
          value={year}
          onChangeText={onYearChange}
        />
      </Box>
    </Box>
  );
}

export default memo(BirthdayInput);
